// src/components/Confirm.js
// for showing confirmation messages like "Are you sure you want to delete this draft? Yes / No"
import React, { useEffect } from "react";
import { IoMdClose } from "react-icons/io";

const Confirm = ({ message, onClose, doAction }) => {

  return (
    <div
      className='fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50'
    >
      <div className='relative bg-white p-10 rounded-lg shadow-lg w-11/12 max-w-xl'>
        <button className='absolute top-3 right-3 text-gray-600' onClick={onClose}>
         <IoMdClose size={22} color="white" className="bg-red-500" />
        </button>
        <div className="mt-2 ">
          {message.includes("To qualify") ?
          <div className="flex flex-col gap-[15px]">
            <p className="text-[20px] font-extrabold text-[var(--color-primary-purple)]">Review Order</p>
            <p className="text-[17px] font-bold">MORE SAMPLES NEEDED FOR HIGH THROUGHPUT ORDER</p>
            <p className="text-[15px] font-semibold">{message}</p>
          </div>
          :
          <div className="text-lg text-center font-semibold">
            {message}
          </div>
          }</div>
        <div className="flex mt-8 justify-center gap-[30px] xl:gap-[60px]">
          <button  
          className="w-[140px] text-center bg-[var(--color-primary-purple)] p-1 rounded-md font-bold text-white"
          onClick={doAction}
          >Yes</button>
          
          <button
          onClick={onClose} 
          className="w-[140px] text-center text-[var(--color-primary-purple)] p-1 rounded-md font-bold bg-gray-200">No</button>
        </div>
      
      </div>
    </div>
  );
};

export default Confirm;
